<div class="card card-primary"><!-- start primary card -->

    <!-- MILEAGE Section -->
    <div [ngSwitch]="userState">
      <div *ngSwitchCase="'authenticated'">
        <div class="card-vehicle-modal-container">
          <div [ngSwitch]="loading">
            <div *ngSwitchCase="true">
              <div class="row" data-ng-cloak>
                <div class="col-12 margin-top-large margin-bottom-large">
                  <div class="text-center">
                    <img translate src="{{'loading_image' | translate}}"
                      altSrc="/ownercenter/content/dam/gmownercenter/gmna/static/siteImages/icons/preloader_chevy.gif"
                      alt="{{'loading_image_alt' | translate}}" class="img-fluid centerFix" role="presentation"
                      aria-hidden="true" />
                  </div>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="false">
              <div [ngSwitch]="activeVehicleMileageState">
                <div *ngSwitchCase="'addMileage'">
                  <div [ngSwitch]="userState">
                    <!-- Vehicle No Mileage -->
                    <div data-ng-show="!this.activeVehicle.odometer">
                      <div class="card-vehicle-no-mileage-intro">
                        <span alt="" aria-hidden="true" class="icon-graphic-mileage"></span>
                        <span class="gb-headline2" role="heading" aria-level="2"
                          [translate]="'activeVehicle_addVehicleMileage_addVehicleMileageText'"></span>

                        <p>
                          <span class="gb-body1" [translate]="'activeVehicle_supportMileage'"></span>
                        </p>

                        <div data-ng-show="addMileageLink" class="col-12 col-lg-4 ml-auto">
                          <span data-gm-track-link="vehProf:addMileage" data-track-delay="true" data-track-type="o"
                            data-prop10="vehProf:link:addMileage">
                            <button class="gb-primary-button {{language}}" (click)="goToAddMileageTemplate()">
                              <span [translate]="'activeVehicle_addCustomerMileage'"></span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Vehicle Add Mileage Form -->
                <div *ngSwitchCase="'addMileageClicked'">
                  <webu-add-mileage 
                      [(activeVehicleMileageState)]="activeVehicleMileageState"
                      [activeVehicle]="activeVehicle"
                      (vehicleMileageUpdate)="vehicleMileageUpdate($event)"
                      [showAddMileageError]="flag.updateMileageError">
                  </webu-add-mileage>
                </div>
              

              <!-- Vehicle with Mileage-->
              <div *ngSwitchCase="'updateMileage'">
                <div [ngSwitch]="userState">
                  <div *ngSwitchCase="'authenticated'">
                    <div class="card-vehicle-mileage-odometer {{language}}">
                      <div class="gb-headline2" role="heading" aria-level="2">
                        {{ activeVehicle.odometer | number }}{{'activeVehicle_milesText' | translate }}
                      </div>
                      <p class="mb-0 gb-body1">
                        <span [translate]="'odometer_lastUpdated'"></span>
                      <!-- Need to fix to use proper fieldAttributes -->
                        <!-- {{activeVehicle.odometerLastUpdated | date: dateFormat.mediumDate}} -->
                        {{formattedDate}}

                      </p>
                      <p>
                        <span class="gb-body1 heavy" [translate]="'garage_label_vin'"></span>&nbsp;
                        <span class="gb-body1">{{activeVehicle.vin}}</span>

                      </p>
                    </div>

                    <div class="card-vehicle-mileage-update">
                      <span data-gm-track-link="vehProf:updateMileage" data-track-delay="true" data-track-type="o"
                        data-prop10="vehProf:button:updateMileage">
                        <button id="UpdateMileageButton" data-ng-show="showMileageUpdateLink"
                          (click)="goToUpdateMileageTemplate()" class="gb-primary-button px-5"
                          [translate]="'activeVehicle_updateMileage'"
                          attr.aria-label="{{'activeVehicle_updateMileage' | translate}}" aria-haspopup="dialog"
                          aria-expanded="false">
                        </button>

                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Update Vehicle Mileage-->
              <div *ngSwitchCase="'updateMileageClicked'">

                <div class="table-container">
                  <div class="table-row">
                    <webu-update-mileage
                    (vehicleMileageUpdate)="vehicleMileageUpdate($event)"
                    [activeVehicle]="activeVehicle"
                    [showUpdateMileageError]="flag.updateMileageError"
                    [(activeVehicleMileageState)]="activeVehicleMileageState">
                  </webu-update-mileage>
                  </div>
                </div>
              </div>
            </div><!--   [ngSwitch]="activeVehicleMileageState" -->
          </div><!-- *ngSwitchCase="false" -->
        </div><!--   [ngSwitch]="loading" -->
      </div><!-- class="card-vehicle-mileage" -->
    </div>
  </div>
</div><!-- class="card card-primary"> -->